import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { flexHorizontal } from "Utils/Styles";

const classNames = {
  root: `Footer`,
  spacer: `FooterSpacer`
};

export function useFooterStyles() {
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          ...flexHorizontal,
          height: `42px`,
          justifyContent: `space-between`
        }
      ],
      spacer: [
        classNames.spacer,
        {
          width: `300px`
        }
      ]
    }),
    []
  );
}
